export interface ITopicDisplay {
    _id?: string;
    project: ITopicDisplayProject;
    title: string;
    participants: ITopicDisplayParticipant[];
    creationDate: Date;
    messageFeed?: string;
    latestMessage?: { text: string; time?: Date };
    isArchived?: boolean;
}

export interface ITopicDisplayParticipant {
    firstName: string;
    lastName: string;
    userId: string;
    profilePictureId?: string;
}

export interface ITopicDisplayProject {
    _id?: string | null;
    title: string;
}

export const INITIAL_TOPIC_DISPLAY: ITopicDisplay = {
    _id: '',
    latestMessage: { text: '' },
    participants: [],
    creationDate: new Date(),
    title: '',
    project: { title: '' },
    messageFeed: '',
};
